// src/components/HeroSection.js
import React from "react";
import "./HeroSection.css";
import heroImage from "../assets/hero-image.png"; // Save your hero image here
// import hours from '../assets/24-hours 1.png'
// import homeIcon from '../assets/homeIcon.png'
// import groomingIcon from '../assets/groomingIcon.png'
// import heartIcon from '../assets/heartIcon.png'
import pawIcon from "../assets/pawIcon.svg";
import starIcon from "../assets/noto_star.svg";
import googleIcon from "../assets/devicon_google.svg";
import { navigateWithUTM } from "../utils/utmHelper";

const HeroSection = ({ mainBookButtonRef }) => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="container">
          {/* The headline text */}

          {/* The image wrapper for styling the border */}
          <div className="hero-image-wrapper">
            <img src={heroImage} alt="Vet providing at-home care for a dog" />
          </div>
          <h1 className="hero-title">
            <span className="highlight">Vets Coming Home</span>
            <br />
            <span className="bottom-text">
              From Our Hospitals to{" "}
              <span className="highlight-blue">Your Home</span>
            </span>
          </h1>
        </div>

        {/* <div className="container hero-stats-grid ">
          <div className="stat-item">
            <img src={hours} alt="24/7 Support" className="stat-icon" />
            <span>24/7 Online Vet<br/>Support</span>
          </div>
          <div className="stat-item">
            <img src={homeIcon} alt="Home Visits" className="stat-icon" />
            <span>Over 10K Home<br/>Vet Visits</span>
          </div>
          <div className="stat-item">
            <img src={groomingIcon} alt="Pet Grooming" className="stat-icon" />
            <span>At-Home Pet<br/>Grooming</span>
          </div>
          <div className="stat-item">
            <img src={heartIcon} alt="Comfort Care" className="stat-icon" />
            <span>Comfort Care<br/>for Sick Pets</span>
          </div>
        </div> */}

        {/* <form className="booking-form container">
          <input type="text" placeholder="Enter Your Name" />
          <input type="tel" placeholder="Phone Number" />
        </form> */}
        <div className="booking-btn-rating">
          <button
            type="submit"
            className="booking-form-button"
            ref={mainBookButtonRef}
            onClick={() => navigateWithUTM("https://doodley.in/BookHomeVisit")}
          >
            <img className="pawIcon" alt="paw" src={pawIcon} />
            BOOK NOW
          </button>
          <p className="hero-ratings">
            4.9 &nbsp;
            <img src={starIcon} alt="star" className="star" /> &nbsp;in &nbsp;
            <img src={googleIcon} alt="google" className="google" />
            &nbsp; Ratings | 20,000+ Pets Cured
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
